const el = document.getElementById('output');
const cursor = document.getElementById('cursor');
const textoFinal = "/midnight_crew";
const caracteresPossiveis = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$";

async function delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

async function iniciarAnimacao() {
  // 1. Inicia com o texto completo
  el.innerText = textoFinal;
  await delay(1000);

  // 2. Apaga o 'w' e o cursor começa a piscar
  el.innerText = "/midnight_cre";
  cursor.classList.add('blink');
  await delay(1000);

  // 3. Volta para o _ (texto completo)
  el.innerText = textoFinal;
  cursor.classList.remove('blink');
  await delay(800);

  // 4. Limpa tudo
  el.innerText = "";
  cursor.classList.add('blink');
  await delay(1000);

  // 5. Volta o texto enquanto embaralha
  for (let i = 0; i <= textoFinal.length; i++) {
    const parteReal = textoFinal.substring(0, i);
    
    // Efeito de embaralhar as letras que ainda não apareceram
    for (let j = 0; j < 5; j++) {
      let rastro = "";
      for (let k = i; k < textoFinal.length; k++) {
        rastro += caracteresPossiveis[Math.floor(Math.random() * caracteresPossiveis.length)];
      }
      el.innerText = parteReal + rastro;
      await delay(40);
    }
  }
  el.innerText = textoFinal;
  cursor.classList.remove('blink');
}

iniciarAnimacao();